import { c as _c } from "react/compiler-runtime";
import { Chips, Choice, MultiChoice, Separator, useTranslationContext } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { match, Pattern } from 'ts-pattern';
import { always, intersection } from 'ramda';
import { isArray } from 'ramda-adjunct';
import { Nullish, suffixTestId, useOnMount } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useChoiceFilter } from '../../hooks/useChoiceFilter';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useLazyChoiceFilterOptions } from '../../hooks/useLazyChoiceFilterOptions';
import { EagFilterProps } from '../../types/EagFilterProps';
import { getFilterFieldName } from '../../utils/getFilterFieldName';
export type ChoiceFilterProps = EagFilterProps & {
  columnKey: string;
  isMulti: boolean;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function ChoiceFilter(props) {
  const $ = _c(33);
  const t = useTranslationContext();
  const rawModel = props.value[FILTER_VALUE_KEY] as string[] | string | Nullish;
  let t0;
  if ($[0] !== props) {
    t0 = newValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: newValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== rawModel || $[3] !== t0) {
    t1 = {
      model: rawModel,
      onChange: t0
    };
    $[2] = rawModel;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [values, setValues] = useChoiceFilter(t1);
  let t2;
  if ($[5] !== props.columnKey) {
    t2 = {
      columnKey: props.columnKey
    };
    $[5] = props.columnKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    loadOptions,
    isLoading,
    options,
    errorMessage
  } = useLazyChoiceFilterOptions(t2);
  let t3;
  if ($[7] !== setValues) {
    t3 = {
      setFilterValue: setValues,
      defaultValue: null
    };
    $[7] = setValues;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t3);
  let t4;
  if ($[9] !== values) {
    t4 = isArray(values) ? values : [values];
    $[9] = values;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = intersection(t4, quickFiltersConst);
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const isQuickFilterValue = t5;
  let t6;
  if ($[13] !== setValues) {
    t6 = changedValues => {
      const correctedValues = match(changedValues).with(Pattern.array(Pattern.string), _temp).with(Pattern.number, _temp2).with(Pattern.string, _temp3).otherwise(always(null));
      setValues(correctedValues);
    };
    $[13] = setValues;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const onChange = t6;
  const isControlDisabled = props.isDisabled || isLoading;
  let t7;
  if ($[15] !== loadOptions) {
    t7 = () => {
      loadOptions();
    };
    $[15] = loadOptions;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useOnMount(t7);
  let t8;
  if ($[17] !== isQuickFilterValue || $[18] !== onChipsChange || $[19] !== props) {
    t8 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("choice-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[17] = isQuickFilterValue;
    $[18] = onChipsChange;
    $[19] = props;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== errorMessage || $[22] !== isControlDisabled || $[23] !== isLoading || $[24] !== onChange || $[25] !== options || $[26] !== props || $[27] !== t || $[28] !== values) {
    t9 = props.isMulti ? <MultiChoice options={options} value={isArray(values) ? values : [values]} onChange={onChange} placeholder={t("page.datagrid.filter.choicePlaceholder", {
      field: getFilterFieldName(props.column)
    })} isDisabled={isControlDisabled} isLoading={isLoading} errorMessage={errorMessage} menuInPortal={true} data-testid={suffixTestId("choice-filter", props)} /> : <Choice options={options} value={isArray(values) ? values[0] : values} onChange={onChange} placeholder={t("page.datagrid.filter.choicePlaceholder", {
      field: getFilterFieldName(props.column)
    })} isDisabled={isControlDisabled} isLoading={isLoading} errorMessage={errorMessage} menuInPortal={true} data-testid={suffixTestId("choice-filter", props)} />;
    $[21] = errorMessage;
    $[22] = isControlDisabled;
    $[23] = isLoading;
    $[24] = onChange;
    $[25] = options;
    $[26] = props;
    $[27] = t;
    $[28] = values;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t8 || $[31] !== t9) {
    t10 = <VStack>{t8}{t9}</VStack>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  return t10;
}
function _temp3(v_1) {
  return [v_1];
}
function _temp2(v_0) {
  return [String(v_0)];
}
function _temp(v) {
  return v;
}